var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-image-frame",style:(_vm.frameStyle)},[_c('img',{directives:[{name:"img",rawName:"v-img",value:({
      title: _vm.title,
      src: _vm.src,
      sourceButton: _vm.sourceButton,
      group: _vm.group,
    }),expression:"{\n      title,\n      src,\n      sourceButton,\n      group,\n    }"}],class:_vm.imageClass,style:(_vm.imageStyle),attrs:{"alt":_vm.title,"src":_vm.thumbnailSrc,"width":_vm.width ? _vm.width : null}})])
}
var staticRenderFns = []

export { render, staticRenderFns }